define(function (require) {

	const dataController = require('./data_controller');

	const viewManager = require('civicsUtils/view_manager');

	return function main_controller(config) {
		let _config = config;
		let _dataController = new dataController(config);

		let _updateFavorites = (model, newNote) =>{
			let favoriteId = model.get('id');
			let collection = model.collection; 
			_dataController.editFavorites(favoriteId, newNote).done(() => {
				collection.resetEditStates();
			}).always(()=>{
				// _showLoadingOverlay(false);
			});
		}
		let _deleteFavorites = (model) =>{
			let favoriteId = model.get('id');
			let collection = model.collection;
			_dataController.deleteFavorite(favoriteId).done(() => {			
				collection.remove(model);
			}).always(()=>{
				// _showLoadingOverlay(false);
			});
		}
		let _addFavoritesAsApplicants = (applicantData) => {
			let instrumentType = config.instrumentType.toLowerCase();
			let instrumentID = config.fromServer.instrumentID;
			let addFavoritesPromise = $.Deferred();

			let applicantModels = _dataController.buildApplicantData(applicantData, instrumentType, instrumentID);
		
			let applicantPromises = applicantModels.map((model) => {
				return _dataController.addApplicants(model);
			});
		
			$.when.apply($, applicantPromises)
			.done(() => {
				addFavoritesPromise.resolve();
			})
			.fail((response) => {
				addFavoritesPromise.reject(response.responseJSON.responseStatus.message);
			})
			.always(() => {
			});
			return addFavoritesPromise.promise();
		};
		let _sendInvitesToFavorites = (applicantData) => {
			let instrumentType = config.instrumentType.toLowerCase();
			let instrumentID = config.fromServer.instrumentID;
			let inviteFavoritesPromise = $.Deferred();

			let inviteModels = _dataController.buildInviteData(applicantData, instrumentType, instrumentID);
		
			let invitePromises = inviteModels.map((model) => {
				return _dataController.inviteContacts(model);
			});
		
			$.when.apply($, invitePromises)
			.done(() => {
				inviteFavoritesPromise.resolve();
			})
			.fail((response) => {
				inviteFavoritesPromise.reject(response.responseJSON.responseStatus.message);
			})
			.always(() => {
			});
			return inviteFavoritesPromise.promise();
		};

		return {
			loadFavorites: _dataController.loadFavorites,
			buildApplicantData: _dataController.buildApplicantData,
			buildInviteData: _dataController.buildInviteData,
			getComparator: _dataController.getComparator,
			processContactsForSubmission: _dataController.processContactsForSubmission,
			getValidApplicants: _dataController.getValidApplicants,
			getValidInvites: _dataController.getValidInvites,
			updateFavorites: _updateFavorites,
			deleteFavorites: _deleteFavorites,
			addFavoritesAsApplicants: _addFavoritesAsApplicants,
			sendInvitesToFavorites: _sendInvitesToFavorites

		}
	}
});
